var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showNavBar)?_c('div',{staticClass:"nav-bar"},[_c('p',{staticClass:"title"},[_vm._v("智能制造地图")]),_c('div',{staticClass:"left-btn",on:{"click":_vm.back}},[_c('van-icon',{attrs:{"name":"arrow-left","size":"24","color":"#333"}})],1)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }